/** See `src/i18n/locales/en/documents.ts`. */
export const documents = {
  page: {
    title: 'Documents',
    lead: 'Téléversez et gérez des documents pour {{company}}.',
    noScope: 'Sélectionnez une entreprise pour voir ses documents.',
    forbidden: "Vous n'êtes pas autorisé à voir les documents de cette entreprise.",
  },
  upload: {
    title: 'Téléverser un document',
    titleField: 'Titre',
    category: 'Catégorie',
    audience: 'Public cible',
    fileUrl: 'URL du fichier',
    file: 'Fichier',
    upload_status: {
      uploading: 'Téléversement en cours…',
      tooLarge: 'Le fichier est trop volumineux (max. 10 Mo).',
      invalidType: 'Type de fichier non autorisé.',
    },
    fileUrlHint: 'Téléversé immédiatement ; ou saisissez une URL existante ci-dessous.',
    requiresReadConfirmation: 'Confirmation de lecture requise',
    requiresReadConfirmationHint: 'Les membres doivent confirmer avoir lu ce document.',
    submit: 'Téléverser',
  },
  categories: {
    algemeen: 'Général',
    beleid: 'Politique',
    veiligheid: 'Sécurité',
    hr: 'RH',
    vitaliteit: 'Vitalité',
  },
  audiences: {
    iedereen: 'Tout le monde',
    management: 'Direction',
    per_afdeling: 'Par département',
    per_locatie: 'Par site',
  },
  status: {
    gepubliceerd: 'Publié',
    archief: 'Archivé',
  },
  library: {
    title: 'Bibliothèque de documents',
    empty: 'Pas encore de documents.',
    totalViews: 'Total des vues : {{count}}',
    columns: {
      title: 'Titre',
      category: 'Catégorie',
      views: 'Vues',
      status: 'Statut',
    },
  },
  actions: {
    new: 'Téléverser un document',
    cancel: 'Annuler',
    publish: 'Publier',
    archive: 'Archiver',
  },
} as const;
